module.exports = __webpack_public_path__ + "img/logo.fa2df22.png";